// extracted by mini-css-extract-plugin
module.exports = {"text_icon":"CrowdersTexticon--text_icon--34xkq","icon_heading":"CrowdersTexticon--icon_heading--2hlLX"};